import { assertHostRpcName } from "./hostRpcNames";
import type { ToolDescriptor } from "./schema";

export type { JsonSchema, ToolDescriptor } from "./schema";

/** Build a descriptor, validating its RPC names against the snapshot. */
export function tool(descriptor: ToolDescriptor): ToolDescriptor {
  for (const name of descriptor.hostRpcNames) assertHostRpcName(name);
  return descriptor;
}
